import { render } from "./ShoppingReviews.vue?vue&type=template&id=47b7930a&scoped=true"
import script from "./ShoppingReviews.vue?vue&type=script&lang=js"
export * from "./ShoppingReviews.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-47b7930a"

export default script